import { Component, HostBinding, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { MatDialog } from '@angular/material/dialog';
import { NavigationService } from '../../services/navigation.service';
import { SharedService }  from "../../../common/services/shared.service";
import { TokenStorageService }  from "../../../common/services/token-storage.service";
import { UserAuthService }  from "../../../common/services/user-auth.service";
import { SidenavService }  from "../../../common/services/sidenav.service";
import { INavItem } from '../../interfaces/nav-item';
import { IBrandProfile } from '../../../common/interfaces/brand-profile';

@Component({
  selector: 'app-menu-list-item',
  templateUrl: './menu-list-item.component.html',
  styleUrls: ['./menu-list-item.component.css'],
  animations: [
    trigger('indicatorRotate', [
        state('collapsed', style({ transform: 'rotate(0deg)' })),
        state('expanded', style({ transform: 'rotate(180deg)' })),
        transition('expanded <=> collapsed',
            animate('225ms cubic-bezier(0.4,0.0,0.2,1)')
        ),
    ])
  ]
})

export class MenuListItemComponent  implements OnInit {
  expanded: boolean = false;

  @HostBinding('attr.aria-expanded') ariaExpanded = this.expanded;
  @Input() item!: INavItem;
  @Input() depth!: number;

  brandStyleTheme: any = {};  

constructor(
    public navService: NavigationService, 
    public router: Router,
    private sharedService: SharedService,  
    private tokenStorageService: TokenStorageService,  
    private userAuthService: UserAuthService,
    private sidenavService: SidenavService,  
    private dialog: MatDialog
  ) {
      if (this.depth === undefined) {
          this.depth = 0;
      }
  }

  ngOnInit() {
      this.navService.getCurrentUrl().subscribe((url: string) => {
        if (this.item.route) {
              this.expanded = url.indexOf(`/${this.item.route}`) === 0;
              this.ariaExpanded = this.expanded;
          }
      });
    // Get the current brand profile
    if (this.sharedService.getBrandProfile()) {
      let brandProfile = this.sharedService.getBrandProfile();
      this.brandStyleTheme = this.sharedService.getBrandStyleScheme(brandProfile);
    }      
  }

  onItemSelected(item: INavItem) {
      this.dialog.closeAll();

      if (!item.children || !item.children.length) {
          if (item.route) {
              // if (item.route == '') {
              //   // clean up current brand and its profile
              //   let emptyBrandProfile: IBrandProfile = {
              //     brandCode: '',
              //     brandName: ''
              //   };
              //   this.sharedService.setEnvRegion('');
              //   this.sharedService.setBaseUrl('');
              //   this.sharedService.setBrandCode('');
              //   this.sharedService.setBrandProfile(emptyBrandProfile);
              //   this.sharedService.setAccountNum('');
              //   this.tokenStorageService.setAuthToken('')
              //   this.tokenStorageService.setUserPrivileges(['']);
              // }
              this.router.navigate([item.route]);
              this.sidenavService.toggle();
          } else {
              this.handleSpecial(item);
          }
      } 

      if (item.children && item.children.length) {
          this.expanded = !this.expanded;
      }
  }

  handleSpecial(item: INavItem) {
      if (item.displayName == 'Sign Out') {
          this.handleSignOut();
      }
  }

  handleSignOut() {
    this.userAuthService.logout();
      //const dialogData = new ConfirmationDialogModel('Confirm', 'Are you sure you want to logout?');
      // const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      //     maxWidth: '400px',
      //     closeOnNavigation: true,
      //     data: dialogData
      // })

      // dialogRef.afterClosed().subscribe(dialogResult => {
      //   if (dialogResult) {
      //       this.authenticationService.logout();
      //     }
      // });
  }

  hasPrivilege(privs: string) {
    return true;
  }

  hasAnyPrivilege(privs: string[]) {
    return true;
  }

  hasAllPrivileges(privs: string[]) {
    return true;
  }

  onSidenavClose() {

  }

}
